module.exports = __webpack_public_path__ + "static/img/16.6008a55.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/16.png
// module id = GSka
// module chunks = 0